import {Component, Inject, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {EditorMmcModelService} from "@irb/irb-editors/editor-mmc-model/editor-mmc-model.service";
import {UtilityService} from "@irb-common/services/utility.service";
import {MmcMarketingDocumentsGridLayoutService} from "@irb/irb-editors/editor-mmc-model/mmc-marketing-documents-dialog/mmc-marketing-documents.grid-layout.service";
import {AppService} from "@irb/app.service";
import {IrbAppEvents} from "@irb/app.events";
import {CalltoactionService} from "@irb-common/components/calltoaction/calltoaction.service";
import {ValidationTextBoxComponent} from "@irb-common/components/validation-text-box/validation-text-box.component";
import {IAlertDialogData} from "@irb/app.model";
import {IrbEditorsEvents} from "@irb/irb-editors/irb-editors.events";


@Component({ standalone: false,
    selector: 'irb-mmc-marketing-documents-dialog',
    templateUrl: './mmc-marketing-documents-dialog.component.html',
    styleUrls: ['./mmc-marketing-documents-dialog.component.scss', '../../../irb-common/styles/dialog.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class MmcMarketingDocumentsDialogComponent implements OnInit {
    @ViewChild('urlValidationTextBox') urlValidationTextBox: ValidationTextBoxComponent;
    linkName: string;
    linkTitle: string;
    marketingDocuments: any;
    originalMarketingDocuments: any;
    file: any;
    hasFile = false;
    isValidFile = true;
    errorMessage = "";
    gridOptions: any;
    grid: any;
    urlRegex = /^((http|https|ftp|ftps)(:\/\/))([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/i;
    hasNotVisibleToAdvisorDocuments = false;
    isModified = false;
    frameworkComponents: any;

    constructor(public dialogRef: MatDialogRef<MmcMarketingDocumentsDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public mdd: any,
                private editorMmcService: EditorMmcModelService,
                private utilService: UtilityService,
                private as: AppService,
                private ctas: CalltoactionService,
                private gls: MmcMarketingDocumentsGridLayoutService) {
        this.marketingDocuments = null;
    }

    ngOnInit(): void {
        this.gridOptions = {
            columnDefs: this.gls.getColumnDefs(this),            
            floatingFilter: false,
            overlayNoRowsTemplate:
                "<span class='ag-overlay-loadGriding-center ag-overlay-message'>There are no links uploaded for this model.</span>",
            context: {componentParent: this},
            isExternalFilterPresent: this.isExternalFilterPresent.bind(this),
            doesExternalFilterPass: this.doesExternalFilterPass.bind(this)
        };

        this.frameworkComponents = this.gls.getFrameworkComponents();

        if (this.mdd) {
            this.updateOverlayNoRowsTemplate();
            this.editorMmcService.getMarketingDocuments(this.mdd?.modelMarketId, false).subscribe((data: any) => {
                let sortedResponseData = JSON.parse(JSON.stringify(data))
                sortedResponseData = this.utilService.sortByKey(sortedResponseData, 'displayOrder', 'asc')
                sortedResponseData = this.orderMarketingDocumentsById(sortedResponseData);
                sortedResponseData = this.getMarketingDocumentsArray(sortedResponseData);
                // sortedResponseData = this.setDisplayOrder(sortedResponseData);
                this.originalMarketingDocuments = sortedResponseData;
                this.marketingDocuments = JSON.parse(JSON.stringify(sortedResponseData));
                this.checkDocumentsNotVisibleToAdvisors();
                this.loadGrid();
                this.onModification();
            }, () => {
            }, () => {
            });
        }
    }
    updateOverlayNoRowsTemplate() {
        this.gridOptions.overlayNoRowsTemplate = this.mdd?.isPaidForModel ? "<span class='ag-overlay-loadGriding-center ag-overlay-message'>There are no marketing document links uploaded for this model.</span>" :
            "<span class='ag-overlay-loadGriding-center ag-overlay-message'>There are no links uploaded for this model.</span>";
    }

    updateGridHeaders() {
        if (this.mdd?.isPaidForModel && this.grid.api) {
            this.grid.api.getColumnDef("file_link").headerName = "Link (opens in new window/tab)";
            this.grid.api.getColumnDef("title").headerName = "Link name/Display text (required)";
            this.grid.api.getColumnDef("deleteFileLink").headerName = "Delete link";
            this.grid.api.refreshHeader();
        }

    }

    close() {
        this.dialogRef.close();
    }

    save() {
        let maxEntries = 5;
        let message = "You may not have more than " + maxEntries + " entries for this model.";
        if (this.exceededDocumentsLinksToSave()) {
            this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
                msg: message,
                dProceedBtnLabel: "Ok",
                onProceed: () => {
                }
            } as IAlertDialogData);
        } else {
            let hasTitleForAll = this.marketingDocuments?.filter((x: any) => !x.isUIdeleted && !x.title)
            let confirmMessage = "Your changes to the Marketing Documents will be immediately visible. Are you sure you want to continue?";
            this.as.fireEvent(IrbAppEvents.SHOW_CONFIRMATION, {
                msg: confirmMessage,
                dProceedBtnLabel:'Save',
                dCancelBtnLabel:'Cancel',
                onProceed: () => {
                    if (hasTitleForAll && hasTitleForAll.length === 0) {
                        this.saveMarketingDocuments();
                    } else {
                        let allTitlesMessage = "Please enter a document title for all files and links.";
                        this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
                            msg: allTitlesMessage,
                            dProceedBtnLabel: "Ok",
                            onProceed: () => {
                            }
                        } as IAlertDialogData);
                    }
                },
                onCancel: () => {
                }
            } as IAlertDialogData);

        }

    }

    onAddLink() {
        this.file = null;
        this.hasFile = false;
        this.isValidFile = true;
        this.errorMessage = "";

        let documentObj = {
            "displayOrder": -1,
            "name": this.linkName,
            "title": this.linkTitle,
            "isUpdated": false,
            "isUIdeleted": false,
            "isNew": true,
            "isVisibleToAdvisors": true,
            "isLink": true,
            "id": new Date().getTime()
        };
        this.marketingDocuments.unshift(documentObj);
        this.marketingDocuments = this.orderMarketingDocumentsById(this.marketingDocuments);
        this.marketingDocuments = this.setDisplayOrder(this.marketingDocuments);
        this.checkDocumentsNotVisibleToAdvisors();
        this.loadGrid();
        this.linkName = "";
        this.linkTitle = "";
        this.as.fireEvent(IrbEditorsEvents.MMC_MARKETING_DOCUMENT_UPLOADED);
        this.onModification();
    }

    delete(data: any) {
        if (data.isNew) {
            let index = -1;
            for (let i = 0; i < this.marketingDocuments.length; i++) {
                if (this.marketingDocuments[i] === data) {
                    index = i;
                    break;
                }
            }
            if (index >= 0 && index < this.marketingDocuments.length ) {
                this.marketingDocuments.splice(index, 1);
            }
        } else {
            data.isUIdeleted = true;
            data.displayOrder = -1;
        }
        this.setDisplayOrder(this.marketingDocuments);
        this.checkDocumentsNotVisibleToAdvisors();
        this.loadGrid();
        this.onModification();
    }

    cancelDelete() {
        this.ctas.remove();
    }

    onGridReady(params: any) {
        this.grid = params;
        this.updateGridHeaders();
        this.loadGrid();
    }

    isExternalFilterPresent() {
        return true;
    }

    doesExternalFilterPass(node: any) {
        return !node.data.isUIdeleted;
    }

    private loadGrid() {
        if (this.grid && this.grid.api && this.marketingDocuments) {
            this.grid.api.setGridOption('rowData', this.marketingDocuments);
        }
    }

    openMarketingDocument(data: any) {
        if (data.isLink) {
            if(this.urlRegex.test(data.name)) {
                window.open(data.name, "_blank");
            } else {
                console.warn("Invalid url can not be opened: " + data.name)
            }
        }


    }

    downArrowClick(paramsData: any) {
        let currentRowIndex = this.marketingDocuments.findIndex((x: any) => x.id === paramsData.data.id);
        let currentItem = this.marketingDocuments[currentRowIndex];
        let nextItem = this.marketingDocuments[currentRowIndex + 1];
        this.marketingDocuments[currentRowIndex] = nextItem;
        this.marketingDocuments[currentRowIndex + 1] = currentItem;
        this.marketingDocuments = this.setDisplayOrder(this.marketingDocuments);
        this.loadGrid();
        this.onModification();

    }

    upArrowClick(paramsData: any) {
        let currentRowIndex = this.marketingDocuments.findIndex((x: any) => x.id === paramsData.data.id);
        let currentItem = this.marketingDocuments[currentRowIndex];
        let prevItem = this.marketingDocuments[currentRowIndex - 1];
        this.marketingDocuments[currentRowIndex] = prevItem;
        this.marketingDocuments[currentRowIndex - 1] = currentItem;
        this.marketingDocuments = this.setDisplayOrder(this.marketingDocuments);
        this.loadGrid();
        this.onModification();
    }

    setDisplayOrder(data: any[]) {
        let index = 0;
        if (data && data.length > 0) {
            for (let i = 0; i < data.length; i++) {
                if (data[i].isUIdeleted) {
                    data[i].displayOrder = -1;
                } else {
                    data[i].displayOrder = index;
                    index++
                }
                data[i].isUpdated = true;
            }
        }
        return data;
    }

    getCount() {
        let count = 0;
        if (this.marketingDocuments && this.marketingDocuments.length > 0) {
            count = (this.marketingDocuments.filter((x: any) => !x.isUIdeleted)).length;
        }
        return count;
    }

    disableAddDocumentLinks() {
        let exceeded = false;
        if (this.mdd) {
            let isPaidModel = this.mdd?.isPaidForModel;
            exceeded = (isPaidModel ? this.getCount() >= 5 : this.getCount() >= 5);
        }
        return exceeded;
    }

    exceededDocumentsLinksToSave() {
        let exceeded = false;
        if (this.mdd) {
            let isPaidModel = this.mdd?.isPaidForModel;
            exceeded = (isPaidModel ? this.getCount() > 5 : this.getCount() > 5);
        }
        return exceeded;
    }

    getMarketingDocumentsArray(items: any[]) {
        let dataArray: any[] = [];

        for (let i = 0; i < items.length; i++) {
            let documentObj = {
                "id": items[i].id,
                "displayOrder": items[i].displayOrder,
                "name": items[i].name,
                "title": items[i].title,
                "isUpdated": items[i].isUpdated,
                "isUIdeleted": items[i].isUIdeleted,
                "isVisibleToAdvisors": items[i].isVisibleToAdvisors,
                "isLink": items[i].isLink
            };
            dataArray.push(documentObj);
        }
        return dataArray;
    }

    checkDocumentsNotVisibleToAdvisors() {
        this.hasNotVisibleToAdvisorDocuments = false;
        if (this.marketingDocuments && this.marketingDocuments.length > 0) {
            let docs = this.marketingDocuments.filter((x: any) => !x.isVisibleToAdvisors);
            this.hasNotVisibleToAdvisorDocuments = (docs.length > 0);
        } else {
            this.hasNotVisibleToAdvisorDocuments = false;
        }
    }

    orderMarketingDocumentsById(data: any[]) {
        if (data && data.length > 0) {
            let allDocuments: any[] = [];
            let nonOrderedDocuments = data.filter((x: any) => x.displayOrder === -1);
            let orderedDocuments = data.filter((x: any) => x.displayOrder !== -1);
            // sort nonOrderedDocuments
            nonOrderedDocuments = this.utilService.sortByKey(nonOrderedDocuments, 'id', 'asc');
            allDocuments.push(...orderedDocuments);
            allDocuments.push(...nonOrderedDocuments);
            return allDocuments;
        } else {
            return data;
        }
    }

    saveMarketingDocuments() {
        this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
        let documents = JSON.parse(JSON.stringify(this.marketingDocuments));
        for (let i = 0; i < documents.length; i++) {
            let docObj = documents[i];
            if (!docObj.isVisibleToAdvisors) {
                docObj.isVisibleToAdvisors = true;
                docObj.isUpdated = true;
            }
            if(!docObj.isUIdeleted) {
                docObj.isUpdated = true;
            }
        }
        this.editorMmcService.saveMarketingDocuments(this.mdd?.modelMarketId, documents)
            .subscribe((response: any) => {
                this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
                if (response) {
                    if (response.success) {
                        this.as.fireEvent(IrbEditorsEvents.MMC_MARKETING_DOCUMENT_UPLOADED);
                        this.close();
                    } else {
                        this.errorMessage = (response.errorMessages && response.errorMessages.length > 0 ? response.errorMessages[0] : 'An error occurred processing your request.');
                    }
                } else {
                    this.errorMessage = "An error occurred processing your request.";
                }
            }, () => {
                this.errorMessage = "An error occurred processing your request.";
                this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
            }, () => {

            });
    }

    hasAllTitles() {
        let isValid = true;
        if(!this.marketingDocuments) {
            return true;
        }
        let hasTitleForAll = this.marketingDocuments?.filter((x: any) => !x.isUIdeleted && !x.title);
        if (hasTitleForAll && hasTitleForAll.length === 0) {
            isValid = true;
        } else {
            isValid = false;
        }
        //this.onModification();
        return isValid;
    }

    onModification() {
        if(this.originalMarketingDocuments && this.marketingDocuments) {
            this.isModified = !this.utilService.compare(this.originalMarketingDocuments, this.marketingDocuments);
        }

    }
    onCellValueChanged(_event: any) {
        this.onModification();
    }
}
